import { render, staticRenderFns } from "./CarrierSettingsTable.vue?vue&type=template&id=08c91865&"
import script from "./CarrierSettingsTable.vue?vue&type=script&lang=js&"
export * from "./CarrierSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports